import eventBus, { eventType } from './eventBus'
import { captureException, flushReplay } from './sentryInstall'
import * as storageUtils from './storageUtils'

export function isInApp () {
  const u = navigator.userAgent
  if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // 安卓手机
    return (typeof android !== 'undefined' && window.android.actGetToken) ? 'android' : false
  } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1 || u.indexOf('Mac') > -1) { // 苹果手机
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.actGetToken) {
      return 'ios'
    }
  }
  return false
}

export function actGetToken () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actGetToken())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveToken = resolve
      window.webkit.messageHandlers.actGetToken.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}

export function actTaobaoIsExist () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actTaobaoIsExist())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveTaobaoIsExist = resolve
      window.webkit.messageHandlers.actTaobaoIsExist.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}
export function actAlibabaIsExist () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actAlibabaIsExist())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveAlibabaIsExist = resolve
      window.webkit.messageHandlers.actAlibabaIsExist.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}

export function actScanCode (scanType, decodeRegex) {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveScanCode = v => {
      actHapticFeedback()
      resolve(v)
    }
    if (app === 'android') {
      try {
        window.android.actScanCode(scanType, decodeRegex)
      } catch (e) {
        window.android.actScanCode()
      }
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actScanCode.postMessage(JSON.stringify({
        scanType,
        decodeRegex
      }))
    } else {
      // resolve('')
    }
  })
}

export function actOpenShareDialog (params) {
  const { shareType, webShareUrl, webShareTxt, webShareImg } = params
  const app = isInApp()
  if (app === 'android') {
    window.android.actOpenShareDialog(shareType, webShareUrl, webShareTxt, webShareImg)
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actOpenShareDialog.postMessage(JSON.stringify({
      shareType,
      webShareUrl,
      webShareTxt,
      webShareImg
    }))
  }
}

export function actJiYunLogin () {
  const app = isInApp()
  if (app === 'android') {
    window.android.actJiYunLogin()
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actJiYunLogin.postMessage('')
  }
}

export function actFinishWebActivity () {
  const app = isInApp()
  if (app === 'android') {
    window.android.actFinishWebActivity()
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actFinishWebActivity.postMessage('')
  }
}

export function actShowWebView () {
  const app = isInApp()
  if (app === 'android') {
    window.android.actShowWebView()
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actShowWebView.postMessage('')
  }
}

export function actWebAllowsBackForwardNavigationGestures (type) {
  const app = isInApp()
  if (app === 'android') {
  } else if (app === 'ios') {
    try {
      window.webkit.messageHandlers.actWebAllowsBackForwardNavigationGestures.postMessage(type)
    } catch (e) {
      // 低版本APP沒有這個方法
    }
  }
}

/**
 * 绑定阿里云推送
 * @param {*} uid
 */
export function actBindAliYunPush (uid) {
  const app = isInApp()
  if (app === 'android') {
    window.android.actBindAliYunPush(uid)
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actBindAliYunPush.postMessage(uid)
  }
}

/**
 * 开启授权登录 Facebook
 */
export function actFBAuthorization () {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPonFBAuthorization = v => {
      // console.log('APPonFBAuthorization', v)
      resolve(v)
    }
    if (app === 'android') {
      window.android.actFBAuthorization()
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actFBAuthorization.postMessage('')
    } else {
      resolve('')
    }
  })
}

/**
 * Apple 登录
 */
export function actAppleIdAuthorization () {
  const app = isInApp()
  return new Promise((resolve, reject) => {
    window.APPonAppleIdAuthorization = v => {
      console.log('APPonAppleIdAuthorization', v)
      if (v) {
        resolve(JSON.parse(v))
      } else {
        reject(v)
      }
    }
    if (app === 'android') {
      window.android.actAppleIdAuthorization()
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actAppleIdAuthorization.postMessage('')
    } else {
      resolve('')
    }
  })
}

export function actGetSystemVersion () {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveSystemVersion = v => {
      resolve(v)
    }
    if (app === 'android') {
      window.android.actGetSystemVersion()
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actGetSystemVersion.postMessage('')
    } else {
      resolve('')
    }
  })
}

export function actGetScreenWidth () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actGetScreenWidth())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveScreenWidth = resolve
      window.webkit.messageHandlers.actGetScreenWidth.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}

export function actGetScreenHeight () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actGetScreenHeight())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveScreenHeight = resolve
      window.webkit.messageHandlers.actGetScreenHeight.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}

export function actCheckWebToUpdate () {
  const app = isInApp()

  return new Promise(resolve => {
    window.APPreceiveWebUpdate = v => {
      resolve(v)
    }
    if (localStorage.actCheckWebToUpdateLastTime && Date.now() - localStorage.actCheckWebToUpdateLastTime < 1000 * 60) {
      return resolve('')
    }
    localStorage.actCheckWebToUpdateLastTime = Date.now()
    if (app === 'android') {
      window.android.actCheckWebToUpdate()
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actCheckWebToUpdate.postMessage('')
    } else {
      resolve('')
    }
  })
}

/**
 * 清空所有Cookie
 */
export function actRemoveAllCookie () {
  const app = isInApp()
  if (app === 'android') {
    window.android.actRemoveAllCookie()
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actRemoveAllCookie.postMessage('')
  }
}

/**
 * 清空H5保存在本地的所有内容
 */
export function actClearLocalstorage () {
  const app = isInApp()
  if (app === 'android') {
    window.android.actClearLocalstorage()
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actClearLocalstorage.postMessage('')
  }
}

export function actGetTaoBaoOrder () {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPonGetTaoBaoOrderResult = v => {
      console.log('APPonGetTaoBaoOrderResult', v)
      resolve(v)
    }
    if (app === 'android') {
      window.android.actGetTaoBaoOrder()
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actGetTaoBaoOrder.postMessage('')
    } else {
      resolve(false)
    }
  })
}

export function actGetAlibabaOrder () {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPonGetAlibabaOrderResult = v => {
      console.log('APPonGetAlibabaOrderResult', v)
      resolve(v)
    }
    if (app === 'android') {
      window.android.actGetAlibabaOrder()
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actGetAlibabaOrder.postMessage('')
    } else {
      resolve(false)
    }
  })
}

export function actTestVersion (versionNum) {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveTestVersion = v => {
      console.log('APPreceiveTestVersion', v)
      resolve(v)
    }
    if (app === 'android') {
      window.android.actTestVersion(versionNum)
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actTestVersion.postMessage(versionNum)
    } else {
    }
  })
}

export function actShopbackIsExist () {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveShopbackIsExist = v => {
      resolve(v)
    }
    if (app === 'android') {
      resolve(window.android.actShopbackIsExist())
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actShopbackIsExist.postMessage('')
    } else {
    }
  })
}

export function actAirHtmlBatchController (type, content, cb) {
  const app = isInApp()
  console.log('actAirHtmlBatchController', type, content)

  return new Promise(resolve => {
    window.APPonAirHtmlBatchController = (errorCode, content) => {
      cb && cb(errorCode, content)
      console.log('APPonAirHtmlBatchController', errorCode, content)
      // if (['400', '200', '201'].indexOf(errorCode) > -1 || type === 'searchTrackingNo') {
      if (errorCode === '109') {
        // 重复请求提示，不处理
        return
      }
      if (errorCode !== '202' || type === 'searchTrackingNo') {
        if (typeof content === 'string') {
          try {
            content = JSON.parse(content)
          } catch (e) {}
        }
        if (content.action === 'actOpenSysBrowser') {
          actOpenSysBrowser(content.contentOne)
        } else {
          resolve({
            errorCode,
            content,
          })
          if (errorCode && errorCode.indexOf('2') !== 0 && errorCode !== '400') {
            captureException(new Error(`actAirHtmlBatchController ${errorCode}`), {
              tags: {
                error_position: 'actAirHtmlBatchController',
                errorCode,
              },
            })
            flushReplay()
          }
        }
      }
    }
    if (app === 'android') {
      window.android.actAirHtmlBatchController(type, typeof content === 'string' ? content : JSON.stringify(content))
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actAirHtmlBatchController.postMessage(JSON.stringify({
        type,
        content: typeof content === 'string' ? content : JSON.stringify(content),
      }))
    } else {
      if (window.vueApp && !window.vueApp.$store.state.isPord) {
        if (type === 'searchTaobaoShoppingCart') {
          resolve({
            errorCode: '200',
            content: [
              {
                traSellerId: '1667979204',
                traSellerName: '千里云海科技',
                traPlatform: 'taobao',
                items: [
                  {
                    itemName: 'Apple/苹果 iPhone 11国行官网未激活苹果11 Pro MaX现货西安速发',
                    itemOrigPrice: '3773.00',
                    itemFinalPrice: '3773.00',
                    itemBrief: '单层不发光【粉色】',
                    itemid: '602991921829',
                    itemPic: 'https://gd3.alicdn.com/imgextra/i4/1667979204/O1CN014mwK4M2HrU5Qd8HWR_!!1667979204.jpg_400x400.jpg',
                    // 'itemCid': '250804',
                    traPlatform: 'taobao'
                  },
                ]
              },
              {
                traSellerId: '3984573045',
                traSellerName: 'jELLYCAT旗舰店',
                traPlatform: 'tmall',
                items: [
                  {
                    itemName: '英国jELLYCAT害羞米色邦尼兔',
                    itemOrigPrice: '149.00',
                    itemFinalPrice: '149.00',
                    itemBrief: '米色;18cm',
                    itemid: '572051330635',
                    itemPic: '//img.alicdn.com/bao/uploaded/i1/3984573045/O1CN0180Q8SN1YMeiBUXa1T_!!0-item_pic.jpg',
                    itemCid: '50011975',
                    traPlatform: 'tmall'
                  },
                  {
                    itemName: '英国巴塞罗熊毛绒安抚玩具',
                    itemOrigPrice: '199.00',
                    itemFinalPrice: '199.00',
                    itemBrief: '棕色;28cm',
                    itemid: '573155642757',
                    itemPic: '//img.alicdn.com/bao/uploaded/i2/3984573045/O1CN011DFwaV1YMel4nEp5H_!!0-item_pic.jpg',
                    itemCid: '50011975',
                    traPlatform: 'tmall'
                  }
                ]
              },
              {
                traSellerId: '407910984',
                traSellerName: '得力官方旗舰店',
                traPlatform: 'tmall',
                items: [
                  {
                    itemName: '得力橡皮泥手工幼儿12色超轻粘土',
                    itemOrigPrice: '39.90',
                    itemFinalPrice: '39.90',
                    itemBrief: '15g杯装-12色+12色补充装（赠整套粘土模具）',
                    itemid: '593050713278',
                    itemPic: '//img.alicdn.com/bao/uploaded/i3/407910984/O1CN01QQxxUL1J8iShRO6AO_!!407910984.jpg',
                    itemCid: '124506010',
                    traPlatform: 'tmall'
                  }
                ]
              }
            ],
          })
        } else if (type === 'searchTaobaoOrder') {
          resolve({
            errorCode: '200',
            content: [
              {
                tradeid: '11230962953079671',
                traStatus: '快件已签收',
                traTrackingNo: 'SF1649492898781',
                traCarrierName: '顺丰速运',
                traSellerId: '2553095546',
                traSellerName: '顾家优品生活馆',
                traAmount: '774.03',
                traDate: '2023-12-18 21:59:34',
                traFreight: '0.00',
                traPlatform: 'taobao',
                items: [
                  {
                    itemName: '法恩迪轻奢岩板茶几电视柜 顾家优品生活馆',
                    itemQty: '1',
                    itemFinalPrice: '957.00',
                    itemBrief: '颜色分类：岩板2205-160CM#电视柜   安装方式：整装   ',
                    itemSkuTitle: '颜色分类：岩板2205-160CM#电视柜   安装方式：整装   ',
                    itemid: '673290765952',
                    itemPic: '//img.alicdn.com/imgextra/i4/2553095546/O1CN01Q8NVyL1qq7Q0NJJxW_!!2553095546.jpg_80x80.jpg',
                    itemCid: ''
                  }]
              }
            ]
          })
        }
      }
    // resolve({
      //   errorCode: '200',
      //   content: [
      //     {
      //       'itemName': 'Apple/苹果 iPhone 11国行官网未激活苹果11 Pro MaX现货西安速发',
      //       'itemOrigPrice': '3773.00',
      //       'itemFinalPrice': '3773.00',
      //       'itemBrief': '单层不发光【粉色】',
      //       'itemid': '602991921829',
      //       'itemPic': 'https://gd3.alicdn.com/imgextra/i4/1667979204/O1CN014mwK4M2HrU5Qd8HWR_!!1667979204.jpg_400x400.jpg',
      //       'itemCid': '250804',
      //       'traPlatform': 'taobao',
      //       itemQty: '1',
      //     }
      //   ]
      // })
      // resolve({
      //   errorCode: '200',
      //   content: [{'traSellerId': '3097225342', 'traSellerName': '惊浪旗舰店', 'traPlatform': 'tmall', 'items': [{'itemName': '高级感重磅博奥宽松休闲裤子男潮', 'itemOrigPrice': '138.00', 'itemFinalPrice': '138.00', 'itemBrief': '深灰色;M[体重100-130斤]', 'itemid': '668580594283', 'itemPic': '//img.alicdn.com/bao/uploaded/i2/3097225342/O1CN01NgTpe61pKgWNe9n3I_!!3097225342.jpg', 'itemCid': '3035', 'traPlatform': 'tmall'}, {'itemName': '阿美咔叽polo短袖宽松保罗衫', 'itemOrigPrice': '108.00', 'itemFinalPrice': '108.00', 'itemBrief': '桔色;S[体重90至120斤]', 'itemid': '668642349981', 'itemPic': '//img.alicdn.com/bao/uploaded/i1/3097225342/O1CN01BRbqJS1pKgWXgwLid_!!3097225342.jpg', 'itemCid': '50010402', 'traPlatform': 'tmall'}]}, {'traSellerId': '2840919441', 'traSellerName': '唯唯礼品', 'traPlatform': 'taobao', 'items': [{'itemName': '太空人不倒翁桌面小摇摆件宇航员益智玩具宇航员不倒翁盲盒扭蛋礼', 'itemOrigPrice': '6.90', 'itemFinalPrice': '6.90', 'itemBrief': '15个太空人不倒翁', 'itemid': '666592403914', 'itemPic': '//img.alicdn.com/bao/uploaded/i1/2840919441/O1CN01TSvWhS2Jc1zMwshJI_!!2840919441.png', 'itemCid': '50013160', 'traPlatform': 'taobao'}]}, {'traSellerId': '411338972', 'traSellerName': '活石母婴专营店', 'traPlatform': 'tmall', 'items': [{'itemName': '儿童遥控汽车可发射对战机甲坦克', 'itemOrigPrice': '188.00', 'itemFinalPrice': '188.00', 'itemBrief': '巨无霸-墨绿黑灯光音乐【遥控手柄+手势感应】升级款;【超值双电】续航70分钟+终身保修+送遥控电池+螺丝刀', 'itemid': '642055764652', 'itemPic': '//img.alicdn.com/bao/uploaded/i2/411338972/O1CN01C8sf4c2G9EDgBxQuU_!!411338972.jpg', 'itemCid': '50023618', 'traPlatform': 'tmall'}]}, {'traSellerId': '3859787182', 'traSellerName': '亿佳果旗舰店', 'traPlatform': 'tmall', 'items': [{'itemName': '狗粮通用型10斤装小型犬冻干粮', 'itemOrigPrice': '43.80', 'itemFinalPrice': '43.80', 'itemBrief': '通用幼犬10斤（营养蛋黄酥&肉粒）三拼', 'itemid': '669122108018', 'itemPic': '//img.alicdn.com/bao/uploaded/i1/3859787182/O1CN019F5h8c22vPHbnDAW1_!!3859787182.jpg', 'itemCid': '50015380', 'traPlatform': 'tmall'}]}, {'traSellerId': '2922903701', 'traSellerName': '益米母婴旗舰店', 'traPlatform': 'tmall', 'items': [{'itemName': '（智能防撞 自动感应）益智玩具', 'itemOrigPrice': '35.00', 'itemFinalPrice': '35.00', 'itemBrief': '电动感应【红】充电款', 'itemid': '644166130541', 'itemPic': '//img.alicdn.com/bao/uploaded/i1/2922903701/O1CN01B3OhIC1dD6YZh46iJ_!!2922903701.jpg', 'itemCid': '50013172', 'traPlatform': 'tmall'}]}, {'traSellerId': '3937219703', 'traSellerName': '天天特卖工厂店', 'traPlatform': 'tmall', 'items': [{'itemName': '3d口罩一次性三层薄款成人口鼻罩', 'itemOrigPrice': '11.70', 'itemFinalPrice': '11.70', 'itemBrief': '50片白色3d成人立体', 'itemid': '666234230555', 'itemPic': '//img.alicdn.com/bao/uploaded/i3/3937219703/O1CN01bxt2iF2LY1l0SMmHw_!!3937219703.jpg', 'itemCid': '50003458', 'traPlatform': 'tmall'}]}, {'traSellerId': '2999154269', 'traSellerName': '三星正品店', 'traPlatform': 'taobao', 'items': [{'itemName': 'Samsung/三星 GALAXY S9+ plus G9650国行双卡全网通4G S10+手机e', 'itemOrigPrice': '980.00', 'itemFinalPrice': '980.00', 'itemBrief': '三星s9 黑色  5.8寸;官方标配;64GB;中国大陆', 'itemid': '659918713851', 'itemPic': '//img.alicdn.com/bao/uploaded/i3/2999154269/O1CN01LXTtzs1hPFT8qTU8D_!!2999154269.jpg', 'itemCid': '1512', 'traPlatform': 'taobao'}]}, {'traSellerId': '2207586290015', 'traSellerName': '原动力数码专营店', 'traPlatform': 'tmall', 'items': [{'itemName': '华为睡眠耳机睡觉专用终生质保', 'itemOrigPrice': '79.90', 'itemFinalPrice': '79.90', 'itemBrief': '官方标配;云墨黑 【入耳真无痛_贴耳超隐形_LED液晶屏显_type-c快充接口】', 'itemid': '667490112498', 'itemPic': '//img.alicdn.com/bao/uploaded/i3/2207586290015/O1CN01qBHfdG1ByuftJrXcu_!!2207586290015.jpg', 'itemCid': '50005050', 'traPlatform': 'tmall'}]}, {'traSellerId': '2540073109', 'traSellerName': '世天电脑', 'traPlatform': 'taobao', 'items': [{'itemName': 'gtx 1060 6g七彩虹影驰独立显卡', 'itemOrigPrice': '1098.00', 'itemFinalPrice': '1098.00', 'itemBrief': '6GB', 'itemid': '623881657103', 'itemPic': '//img.alicdn.com/bao/uploaded/i1/2540073109/O1CN01DE62ql1Ypy1qlij2d_!!2540073109.jpg', 'itemCid': '110206', 'traPlatform': 'taobao'}]}],
      // })
      // resolve({
      //   errorCode: '200',
      //   content: [
      //     {
      //       'traSellerId': '1667979204',
      //       'traSellerName': '千里云海科技',
      //       'traPlatform': 'taobao',
      //       'items': [
      //         {
      //           'itemName': 'Apple/苹果 iPhone 11国行官网未激活苹果11 Pro MaX现货西安速发',
      //           'itemOrigPrice': '3773.00',
      //           'itemFinalPrice': '3773.00',
      //           'itemBrief': '单层不发光【粉色】',
      //           'itemid': '602991921829',
      //           'itemPic': 'https://gd3.alicdn.com/imgextra/i4/1667979204/O1CN014mwK4M2HrU5Qd8HWR_!!1667979204.jpg_400x400.jpg',
      //           // 'itemCid': '250804',
      //           'traPlatform': 'taobao'
      //         },
      //       ]
      //     },
      //     {
      //       'traSellerId': '3984573045',
      //       'traSellerName': 'jELLYCAT旗舰店',
      //       'traPlatform': 'tmall',
      //       'items': [
      //         {
      //           'itemName': '英国jELLYCAT害羞米色邦尼兔',
      //           'itemOrigPrice': '149.00',
      //           'itemFinalPrice': '149.00',
      //           'itemBrief': '米色;18cm',
      //           'itemid': '572051330635',
      //           'itemPic': '//img.alicdn.com/bao/uploaded/i1/3984573045/O1CN0180Q8SN1YMeiBUXa1T_!!0-item_pic.jpg',
      //           'itemCid': '50011975',
      //           'traPlatform': 'tmall'
      //         },
      //         {
      //           'itemName': '英国巴塞罗熊毛绒安抚玩具',
      //           'itemOrigPrice': '199.00',
      //           'itemFinalPrice': '199.00',
      //           'itemBrief': '棕色;28cm',
      //           'itemid': '573155642757',
      //           'itemPic': '//img.alicdn.com/bao/uploaded/i2/3984573045/O1CN011DFwaV1YMel4nEp5H_!!0-item_pic.jpg',
      //           'itemCid': '50011975',
      //           'traPlatform': 'tmall'
      //         }
      //       ]
      //     },
      //     {
      //       'traSellerId': '407910984',
      //       'traSellerName': '得力官方旗舰店',
      //       'traPlatform': 'tmall',
      //       'items': [
      //         {
      //           'itemName': '得力橡皮泥手工幼儿12色超轻粘土',
      //           'itemOrigPrice': '39.90',
      //           'itemFinalPrice': '39.90',
      //           'itemBrief': '15g杯装-12色+12色补充装（赠整套粘土模具）',
      //           'itemid': '593050713278',
      //           'itemPic': '//img.alicdn.com/bao/uploaded/i3/407910984/O1CN01QQxxUL1J8iShRO6AO_!!407910984.jpg',
      //           'itemCid': '124506010',
      //           'traPlatform': 'tmall'
      //         }
      //       ]
      //     }
      //   ],
      // })
    }
  })
}

export function actAirHtmlBatchDistributeController (type, content, askString, selectOrderId) {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPonAirHtmlBatchDistributeController = (errorCode, content, askString) => {
      resolve({
        errorCode,
        content,
        askString
      })
    }
    if (app === 'android') {
      window.android.actAirHtmlBatchDistributeController(type, content, askString, selectOrderId)
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actAirHtmlBatchDistributeController.postMessage(JSON.stringify({
        type,
        content,
        askString,
        selectOrderId
      }))
    }
  })
}

/**
 * 本地化轻量存储工具 Set
 * @param {*} key
 * @param {*} value
 */
export function actSetUdSpUtil (key, value) {
  const app = isInApp()
  if (app === 'android') {
    window.android.actSetUdSpUtil(key, value)
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actSetUdSpUtil.postMessage(JSON.stringify({
      key,
      value
    }))
  }
}

/**
 * 本地化轻量存储工具 Get
 * @param {*} key
 */
export function actGetUdSpUtil (key) {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actGetUdSpUtil(key))
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveUdSpUtil = resolve
      window.webkit.messageHandlers.actGetUdSpUtil.postMessage(key)
    })
  }
}

/**
 * 本地化轻量存储工具 Del
 * @param {*} key
 */
export function actDelUdSpUtil (key) {
  const app = isInApp()
  if (app === 'android') {
    window.android.actDelUdSpUtil(key)
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actDelUdSpUtil.postMessage(key)
  }
}

/**
 * 告诉APP当前用户选择使用的颜色模式
 * 0 是浅色模式  1 是深色模式
 * @param {*} webColorMode
 */
export function actWebColorMode (webColorMode) {
  const app = isInApp()
  if (app === 'android') {
    window.android.actWebColorMode(webColorMode)
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actWebColorMode.postMessage(webColorMode)
  }
}

/**
 * 關閉Web页面使用的方法，如果当前Web页面有上一级可以返回，就返回上级页面，如果无则關閉这个页面。
 */
export function actFinishOrBackWeb () {
  console.log('appSDK call actFinishOrBackWeb')
  const app = isInApp()
  if (app === 'android') {
    window.android.actFinishWeb()
  } else if (app === 'ios') {
    // history.back()
    window.webkit.messageHandlers.actFinishWeb.postMessage('')
  }
}

export function actHapticFeedback (type = '1', t = 100) {
  const app = isInApp()
  // window.navigator.vibrate(t)
  if (app === 'android' || !app) {
    if (window.navigator.vibrate) {
      window.navigator.vibrate(t)
    }
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actHapticFeedback.postMessage(type)
  }
}

export function actVibrate (t = 100) {
  const app = isInApp()
  // window.navigator.vibrate(t)
  if (app === 'android' || !app) {
    if (window.navigator.vibrate) {
      window.navigator.vibrate(t)
    }
  } else if (app === 'ios') {
    if (window.webkit.messageHandlers.actVibrate) {
      window.webkit.messageHandlers.actVibrate.postMessage('')
    }
  }
}

export function finishWeb () {
  actCurrency(2, {
    action: 'finish'
  })
}

export function actGetClipboard () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actGetClipboard())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveClipboard = resolve
      window.webkit.messageHandlers.actGetClipboard.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}

/**
 * 当新开启一个web页面的时候，如果上一个web页面有intentContent传递过来，就会返回intentContent的值，反之返回空字符串
 */
export function actGetIntentContent () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actGetIntentContent())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveIntentContent = resolve
      window.webkit.messageHandlers.actGetIntentContent.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}

/**
 * web是否监听app的返回键，如果调用该方法，用户在当前页面点击返回页面的时候，app会调用window.handleKeyBack()
 */
export function actBackHook (listen) {
  const app = isInApp()
  if (app === 'android') {
    if (listen) {
      window.android.actBackHook(1, 1)
    } else {
      window.android.actBackHook(0, 0)
    }
  } else if (app === 'ios') {
    if (listen) {
      window.webkit.messageHandlers.actBackHook.postMessage(JSON.stringify({
        startListenBack: 1,
        closeAppBack: 1
      }))
    } else {
      window.webkit.messageHandlers.actBackHook.postMessage(JSON.stringify({
        startListenBack: 0,
        closeAppBack: 0
      }))
    }
  }
}

export function actGetAppVersion () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actGetAppVersion())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveAppVersion = resolve
      window.webkit.messageHandlers.actGetAppVersion.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}

/**
 * 打开自带浏览器
 */
export function actOpenSysBrowser (url) {
  const app = isInApp()
  if (app === 'android') {
    window.android.actOpenSysBrowser(url)
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actOpenSysBrowser.postMessage(url)
  } else {
    window.open(url)
  }
}

/**
 * 获取用户设备名称
 */
export function actGetDeviceName () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actGetDeviceName())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveDeviceName = resolve
      window.webkit.messageHandlers.actGetDeviceName.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}

/**
 * 获取用户设备UDID
 */
export function actGetDeviceUDID () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actGetDeviceUDID())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveDeviceUDID = resolve
      window.webkit.messageHandlers.actGetDeviceUDID.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}

/**
 * 获取当前用户的设备类型。比如:iPhone X、Galaxy S8+
 */
export function actGetDeviceType () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actGetDeviceType())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveDeviceType = resolve
      window.webkit.messageHandlers.actGetDeviceType.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}

export function actGetWebServerPort () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actGetWebServerPort())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveWebServerPort = resolve
      window.webkit.messageHandlers.actGetWebServerPort.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}

/**
 * 判断当前用户生物验证开启或支持情况
 * type=0表示本设备不支持生物验证(没有生物验证硬件模块) type=1表示本设备支持生物验证并且，已经开通生物验证 type=2表示本设备支持生物验证并且，但未开通生物验证
 */
export function actIsBiometricPromptEnable () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actIsBiometricPromptEnable())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceiveBiometricPromptEnable = resolve
      window.webkit.messageHandlers.actIsBiometricPromptEnable.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}

/**
 * 關閉本地生物验证，并清 空生物验证的私钥，后续要使用需 要用户重新开启
 */
export function actAuthenticateBiometricClear () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(window.android.actAuthenticateBiometricClear())
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.webkit.messageHandlers.actAuthenticateBiometricClear.postMessage('')
    })
  } else {
    return Promise.resolve('')
  }
}

/**
 * str为需要加 密的内容，str 为空则会开启生物验证
 *
 * {"sign":"", "type":1, "verif":0}
 * sign:私钥加签后的结果
 * type=0表示本设备不支持生物验证(没有生物验证硬件模 块);
 * type=1表示本设备支持生物验证并且，已经开通生物验 证;
 * type=2表示本设备支持生物验证并且，但未开通生物验证
 * verif=0验证失败，verif=1验证成功
 */
export function actAuthenticateBiometric (str = '') {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPonAuthenticateBiometric = v => {
      resolve(JSON.parse(v))
    }
    if (app === 'android') {
      window.android.actAuthenticateBiometric(str)
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actAuthenticateBiometric.postMessage(str)
    } else {
      resolve(false)
    }
  })
}

/*
2.增加actNetwork方法，传入范例：{"url":"/post/v1frontend/post/index","method":"GET","errorCall":"tttt","successCall":"xxxx","header":{"acct":"ssss"},"params":{"type":"emer","pageSize":"1"},"addQAuth":true,"addBaseUrl":true}

说明：
url=需要加载的地址；

method=使用的请求方式；

successCall和errorCall=如果网络请求错误会回调这个方法明，比如上面的范例，回调就会把错误的字符串传递给tttt这个方法
header=请求用的头内容

params=请求用的主体

addQAuth=APP是否添加巧巧郎的认证信息，如果true，则app会自动在请求头和主体内加上"device-udid"/"device-type"/"device-name"/"accessToken"，所以用了addQAuth，就不用再传递这些了；

addBaseUrl=是否在当前请求前加上"https://api.jyb.com.tw"这个基本请求地址，如范例，url就会变成"https://api.jyb.com.tw/post/v1frontend/post/index"，这个目的是为了隐藏基础域名地址，防止被web监听到
*/
export function actNetwork (data) {
  const app = isInApp()

  const netWorkParams = {
    addQAuth: true,
    addBaseUrl: true,
    ...data,
  }
  return new Promise((resolve, reject) => {
    const successCall = 'APPonNetworkSuccessCall' + Math.random().toString(36).substr(2)
    const errorCall = 'APPonNetworkErrorCall' + Math.random().toString(36).substr(2)
    window[successCall] = resolve
    window[errorCall] = reject
    netWorkParams.successCall = successCall
    netWorkParams.errorCall = errorCall
    if (app === 'android') {
      window.android.actNetwork(JSON.stringify(netWorkParams))
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actNetwork.postMessage(JSON.stringify(netWorkParams))
    }
  })
}

export function actSBV (str = '') {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveSBV = v => {
      resolve(JSON.parse(v))
    }
    if (app === 'android') {
      window.android.actSBV(str)
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actSBV.postMessage(str)
    } else {
      // resolve(false)
    }
  })
}

export function actCurrency (type, content) {
  const app = isInApp()

  if (app === 'android') {
    window.android.actCurrency(type, JSON.stringify({
      android: content
    }))
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actCurrency.postMessage(JSON.stringify({
      type: `${type}`,
      content: JSON.stringify({
        ios: content
      })
    }))
  }
}

export function openWeb (to, params) {
  let loadUrl
  if (/^https?:/.test(to)) {
    loadUrl = to
  } else {
    const resolveReturn = window.vueApp.$router.resolve(to)
    loadUrl = `${location.origin}${location.pathname}${resolveReturn.href}`
  }

  if (isInApp()) {
    actCurrency(2, {
      action: 'openWeb',
      loadUrl,
      // title:'',
      titleVisibility: 0,
      isShare: 0,
      webfull: 1,
      // statusBarColor: '',
      // statusBarTextIsWhite: '',
      // intentContent: JSON.stringify({
      //   user: store.state.user,
      //   userAddrs: store.state.userAddrs,
      //   jyShippingRates: store.state.jyShippingRates,
      //   jyWarehouses: store.state.jyWarehouses,
      //   jyShippingRatesSource: store.state.jyShippingRatesSource
      // }),
      ...params
    })
  } else {
    window.open(loadUrl)
    // if (/^https?:/.test(to)) {
    //   window.open(to)
    // } else {
    //   console.log(to)
    //   window.vueApp.$router.push(to)
    // }
  }
}

/**
 * 当A页面开启B页面，B页面關閉的时候想把部分数据传回给A页面
 * 则调用actSetIntentContentForResult方法, A 页面会触发 onActivityResult
 * @param {*} data
 */
export function actSetIntentContentForResult (data) {
  const app = isInApp()
  if (app === 'android') {
    window.android.actSetIntentContentForResult(JSON.stringify(data))
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actSetIntentContentForResult.postMessage(JSON.stringify(data))
  }
}

/**
 * 获取当前用户的设备状态栏的高度
 */
export function actGetPhoneStatusBarHeight () {
  const app = isInApp()
  if (app === 'android') {
    return Promise.resolve(parseInt(window.android.actGetPhoneStatusBarHeight()) / window.devicePixelRatio)
  } else if (app === 'ios') {
    return new Promise(resolve => {
      window.APPreceivePhoneStatusBarHeight = (v) => {
        const h = parseInt(v)
        resolve(h)
      }
      window.webkit.messageHandlers.actGetPhoneStatusBarHeight.postMessage('')
    })
  } else {
    return Promise.resolve(0)
  }
}

export function actCheckNotification () {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveCheckNotification = v => {
      resolve(v)
    }
    if (app === 'android') {
      resolve(window.android.actCheckNotification())
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actCheckNotification.postMessage('')
    } else {
    }
  })
}

export function actShotApp () {
  // 安卓版本号要>=1.1.2，ios>=1.1.5
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveShotApp = v => {
      resolve(v)
    }
    if (app === 'android') {
      window.android.actShotApp()
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actShotApp.postMessage('')
    } else {
    }
  })
}

export function actShotAppBase64 () {
  // 安卓版本号要>=1.1.3，ios>=1.1.6
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveShotAppBase64 = v => {
      resolve(v)
    }
    if (app === 'android') {
      window.android.actShotAppBase64()
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actShotAppBase64.postMessage('')
    } else {
    }
  })
}

export function actOpenSetingNotification () {
  const app = isInApp()
  if (app === 'android') {
    window.android.actOpenSetingNotification()
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actOpenSetingNotification.postMessage('')
  }
}

// 监听陀螺仪
export function actGetGyroscope (cb) {
  const app = isInApp()
  window.APPreceiveGyroscope = (x, y, z) => {
    if (cb) {
      // eslint-disable-next-line standard/no-callback-literal
      cb({
        x,
        y,
        z,
      })
    }
  }
  if (app === 'android') {
    window.android.actGetGyroscope()
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actGetGyroscope.postMessage('')
  }
}

// 停止监听陀螺仪
export function actStopGyroscope (cb) {
  const app = isInApp()
  if (app === 'android') {
    window.android.actStopGyroscope()
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actStopGyroscope.postMessage('')
  }
}

/**
 * 修改状态栏颜色
 * @param {*} color
 * @param {number} statusBarTextIsWhite 1 白色 0 黑色
 */
export function actSetStatusBarColor (color, statusBarTextIsWhite = 1) {
  const app = isInApp()
  if (app === 'android') {
    window.android.actSetStatusBarColor(color, statusBarTextIsWhite)
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actSetStatusBarColor.postMessage(JSON.stringify({
      color,
      statusBarTextIsWhite
    }))
  }
}

/**
 * 与 actSetStatusBarColor 功能一样，测试用
 */
export function setStatusBarColor (statusBarColor, statusBarTextIsWhite = 1) {
  actCurrency(2, {
    action: 'setStatusBarColor',
    statusBarColor,
    statusBarTextIsWhite
  })
}

export function openRich ({ title, content, titleVisibility = 1 }) {
  actCurrency(2, {
    action: 'openRich',
    title,
    content,
    titleVisibility
  })
}

export function openViewPagerPho ({ title, content }) {
  actCurrency(2, {
    action: 'openViewPagerPho',
    title,
    content
  })
}

export function openShare (params) {
  console.log('openShare', params)
  const { shareName, shareUrl, shareTxt, shareImg } = params
  actCurrency(2, {
    action: 'openShare',
    shareName,
    shareUrl,
    shareTxt,
    shareImg
  })
}

export function login (otherAction = '') {
  actCurrency(2, {
    action: 'login',
    otherAction
  })
}

export function actWebToUpdate ({ version, dowLoadUrl, zipSize }) {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveWebUpdate = v => {
      resolve(v)
    }
    if (app === 'android') {
      window.android.actWebToUpdate(version, dowLoadUrl)
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actWebToUpdate.postMessage(JSON.stringify({
        version,
        dowLoadUrl,
        zipSize,
      }))
    }
  })
}

export function actDownFile (url) {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveDownComplete = v => {
      resolve(v)
    }
    if (app === 'android') {
      window.android.actDownFile(url)
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actDownFile.postMessage(url)
    } else {
      resolve(false)
    }
  })
}

export function actBreakDown () {
  const app = isInApp()
  return new Promise(resolve => {
    if (app === 'android') {
      resolve(window.android.actBreakDown())
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actBreakDown.postMessage('')
    } else {
    }
  })
}

export function actSubmitVideoToS3 () {
  const app = isInApp()
  return new Promise(resolve => {
    if (app === 'android') {
      resolve(window.android.actSubmitVideoToS3())
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actSubmitVideoToS3.postMessage('')
    } else {
    }
  })
}

export function actPlaySound (url) {
  console.log('actPlaySound', url)
  const app = isInApp()
  return new Promise(resolve => {
    if (app === 'android') {
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actPlaySound.postMessage(url)
    }
  })
}

export function actSoundPause () {
  console.log('actSoundPause')
  const app = isInApp()
  return new Promise(resolve => {
    if (app === 'android') {
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actSoundPause.postMessage('')
    }
  })
}

export function actSubmitToS3 (videoUUID) {
  const app = isInApp()
  return new Promise(resolve => {
    // window.APPreceiveSubmitToS3Complete = v => {
    //   resolve(v)
    // }
    if (app === 'android') {
      window.android.actSubmitToS3(videoUUID)
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actSubmitToS3.postMessage(videoUUID)
    } else {
      resolve(false)
    }
  })
}

// 应用商店评价按设备 365 天内只触发一次（storageUtils 过期时间单位为分钟）
const STORE_REVIEW_EXPIRED_MINUTES = 60 * 24 * 365
export function actStoreReview (APPID = '') {
  const app = isInApp()
  return new Promise(resolve => {
    // window.APPreceiveSubmitToS3Complete = v => {
    //   resolve(v)
    // }
    if (storageUtils.get(`actStoreReview_${APPID}`)) {
      return
    }
    if (app === 'android') {
      window.android.actStoreReview(APPID)
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actStoreReview.postMessage(APPID)
    }
    storageUtils.set(`actStoreReview_${APPID}`, 1, STORE_REVIEW_EXPIRED_MINUTES)
  })
}

// 买即可 App 应用商店评价：iOS 需传 App Store ID，Android 不传；仅 App 内触发
const MGB_IOS_APPID = '6480051573'
export function actMgbStoreReview () {
  const app = isInApp()
  if (!app) return
  actStoreReview(app === 'ios' ? MGB_IOS_APPID : '')
}

/**
 * 开启灵动岛通知
 * {"titleOne":"标题1","titleTwo":"标题2","titleThree":"标题3","titleSub":"小标题","islandText":"灵动岛文本","progress":30}
 */
export function actStartIsland (data) {
  console.log('actStartIsland', data)
  const app = isInApp()
  if (app === 'android') {
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actStartIsland.postMessage(JSON.stringify(data))
  }
}

/**
 * 更新灵动岛通知
 * {"titleOne":"标题1","titleTwo":"标题2","titleThree":"标题3","titleSub":"小标题","islandText":"灵动岛文本","progress":30}
 */
export function actUpdateIsland (data) {
  const app = isInApp()
  if (app === 'android') {
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actUpdateIsland.postMessage(JSON.stringify(data))
  }
}

/**
 * 停止灵动岛通知
 */
export function actStopIsland () {
  const app = isInApp()
  if (app === 'android') {
  } else if (app === 'ios' && window.webkit.messageHandlers.actStopIsland) {
    window.webkit.messageHandlers.actStopIsland.postMessage('')
  }
}

// 0=不允許旋轉屏幕；1=允許旋轉屏幕
export function actAllowRotation (data) {
  const app = isInApp()
  if (app === 'android') {
    window.android.actAllowRotation(data)
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actAllowRotation.postMessage(data)
  }
}

// 长截屏
export function actLongShotApp (data) {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveLongShotAppBase64 = v => {
      resolve(v)
    }
    if (app === 'android') {
      // window.android.actLongShotApp(url)
    } else if (app === 'ios') {
      // ver >= 1.2.8
      window.webkit.messageHandlers.actLongShotApp.postMessage(data)
    } else {
    }
  })
}

// 打开相机
export function actOpenCameraView (data) {
  const { mask, width, height, x, y } = data
  // actOpenCameraView(String mask ,String width,String hength,String x,String y)
  // {"mask":"https://pb.artjsj.com/pho/33333.png","width":"300","length":"300","x":"20","y": "20"}
  const app = isInApp()
  if (app === 'android') {
    window.android.actOpenCameraView(mask, width, height, x, y)
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actOpenCameraView.postMessage(JSON.stringify(data))
  }
}

// 调用直接关闭并释放掉这个相机拍摄
export function actCloseCameraView () {
  const app = isInApp()
  if (app === 'android') {
    window.android.actCloseCameraView()
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actCloseCameraView.postMessage('')
  }
}

export function actFaceAuthFacade (CertifyId) {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveFaceAuthFacade = v => {
      resolve(JSON.parse(v))
    }
    if (app === 'android') {
      window.android.actFaceAuthFacade(CertifyId)
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actFaceAuthFacade.postMessage(CertifyId)
    }
  })
}

export function actGetMetaInfo () {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveMetaInfo = v => {
      resolve(v)
    }
    if (app === 'android') {
      resolve(window.android.actGetMetaInfo())
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actGetMetaInfo.postMessage('')
    }
  })
}

// 调用后拍摄当前显示的画面
export function actTakeCameraView (data) {
  const app = isInApp()
  return new Promise(resolve => {
    window.APPreceiveShotAppBase64 = v => {
      resolve(v)
    }
    if (app === 'android') {
      window.android.actTakeCameraView()
    } else if (app === 'ios') {
      window.webkit.messageHandlers.actTakeCameraView.postMessage('')
    } else {
    }
  })
}

// 是否开启闪光灯；传递1/0，默认为0（关闭），1（开启）
export function actOpenCameraFlash (v) {
  const app = isInApp()
  if (app === 'android') {
    window.android.actOpenCameraFlash(v)
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actOpenCameraFlash.postMessage(v)
  }
}

// 保存图片到相册
export function actSaveImg (v) {
  const app = isInApp()
  if (app === 'android') {
    window.android.actSaveImg(v)
  } else if (app === 'ios') {
    window.webkit.messageHandlers.actSaveImg.postMessage(v)
  }
}

window.APPonResume = () => eventBus.$emit(eventType.APPonResume)
window.APPonPause = () => eventBus.$emit(eventType.APPonPause)
window.APPonDestroy = () => eventBus.$emit(eventType.APPonDestroy)
window.APPonActivityResult = (v) => eventBus.$emit(eventType.APPonActivityResult, v)
window.APPhandleKeyBack = () => eventBus.$emit(eventType.APPhandleKeyBack)
window.APPreceiveScreenshots = (v) => eventBus.$emit(eventType.APPreceiveScreenshots, v)
window.APPonColorMode = (v) => eventBus.$emit(eventType.APPonColorMode, v)
window.APPreceiveProgress = (v) => eventBus.$emit(eventType.APPreceiveProgress, v)
window.APPreceiveSubmitToS3Complete = (v) => eventBus.$emit(eventType.APPreceiveSubmitToS3Complete, v)
window.APPreceiveMotionBegan = (v) => eventBus.$emit(eventType.APPreceiveMotionBegan, v)
window.APPreceiveMotionEnded = (v) => eventBus.$emit(eventType.APPreceiveMotionEnded, v)
// APPreceiveMotionEnded(2)
